import React, {useState} from 'react';
import {Box, Link, ListItemIcon, ListItemText, Menu, MenuItem} from '@material-ui/core';
import {capitalize} from "../../../../helpers/utils";
import {NavLink} from "react-router-dom";
import EditIcon from '@material-ui/icons/Edit';
import LinkIcon from '@material-ui/icons/Link';
import PersonIcon from '@material-ui/icons/Person';
import Tooltip from "@material-ui/core/Tooltip";
import WarningReasonIcon from "./WarningReasonIcon";

const WarningDescription = ({warning, from}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleCloseMenu = (event) => {
        setAnchorEl(null);
    }

    const hasTeamExtraData = ["member_warning", "former_member_warning", "missing_contact_warning", "potential_dup_warning"].includes(warning.type_of_warning);

    return (
        <>
            {
                (hasTeamExtraData)  ? <>
                    <Box>
                        <Link
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={handleOpenMenu}
                        >
                            {warning.description}
                        </Link>
                        <Menu
                            anchorEl={anchorEl}
                            keepMounted
                            open={open}
                            onClose={handleCloseMenu}
                            PaperProps={{
                                style: {
                                    maxHeight: 40 * 4.5,
                                },
                            }}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                        >
                            {warning.extra_data.teams && warning.extra_data.teams.map(({id, name, crd_id=null, reasons}) => (
                                <MenuItem key={id}>
                                    <ListItemText primary={
                                        <NavLink
                                            key={id}
                                            to={{
                                                pathname:`/admin/live_data/private_wealth_teams`,
                                                search: `?team_id=${id}`,
                                                state: {from: from}
                                            }}
                                        >
                                            {`${name} ${crd_id ? "(" + crd_id + ")" : ""}`}
                                        </NavLink>
                                    } />
                                    {
                                        reasons?.length > 0 ? <ListItemIcon style={{marginLeft: "10px"}}>
                                            {
                                                reasons.map((reason, index) => <WarningReasonIcon key={index} reason={reason} />)
                                            }
                                        </ListItemIcon> : null
                                    }
                                </MenuItem>
                            ))}
                            {warning.extra_data.foundation_contacts && warning.extra_data.foundation_contacts.map(({id, name, reasons}) => (
                                <MenuItem key={id}>
                                    <ListItemText primary={name} />
                                    {
                                        reasons?.length > 0 ? <ListItemIcon style={{marginLeft: "10px"}}>
                                            {
                                                reasons.map((reason, index) => <WarningReasonIcon key={index} reason={reason} />)
                                            }
                                        </ListItemIcon> : null
                                    }
                                </MenuItem>
                            ))}
                            {warning.extra_data.foundations && warning.extra_data.foundations.map(({id, name, reasons}) => (
                                <MenuItem key={id}>
                                    <ListItemText primary={name} />
                                    {
                                        reasons?.length > 0 ? <ListItemIcon style={{marginLeft: "10px"}}>
                                            {
                                                reasons.map((reason, index) => <WarningReasonIcon key={index} reason={reason} />)
                                            }
                                        </ListItemIcon> : null
                                    }
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </> : <>
                    {warning.description}
                </>
            }
        </>
    )
}

export default WarningDescription;
